<script lang="ts">
  import { navigate } from "../../app.logic";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";
  import type { IContact } from "../../entities";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import {
    addActivity,
    activities,
    customFieldsSchemas,
    completeActivity,
    record,
    save,
  } from "./contact.store";
  import ContactEditForm from "./ContactEditForm.svelte";
import ActivityListEditor from "../../components/Business/ActivityListEditor.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.firstName != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IContact> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/contact/${u.oid}`);
    } else {
      onCancel();
    }
  }


  async function onEditActivity(event)
  {

  }

  function onCancel() {
    navigate(`/contact`);
  }

  // onMount(() => initDetail(oid));
</script>

{#if $record}
  <div class="columns">
    <div class="column is-9">
      <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        <ContactEditForm {record} />
        <CustomFields
          schemas={$customFieldsSchemas}
          bind:values={$record.customFields}
        />
      </FormLayout>
    </div>
    <div class="column is-3">
      <!--
      <div class="box">
        <h1 class="subtitle">Riepilogo</h1>
      </div>
    -->

      <ActivityListEditor
      entityId={$record.oid}
      entityType={'Contact'}
      activities={$activities}
      disabled={isNew}        
      on:save={addActivity} 
      on:edit={onEditActivity}
      on:complete={completeActivity}
    />    
    </div>
  </div>
{/if}
